<template>
  <div class="adsCreateAds">
    <div class="content-div">
      <b-tabs class="tabs-list" v-model="tabIndex">
        <b-tab active>
          <template v-slot:title><div class="title">{{$t('current ad')}}</div></template>
          <div class="tab-lists">
            <div class="banner-list-row">
              <b-card
                no-body
                class="mb-1"
                v-for="(location, index) in adsLocations"
                v-bind:key="index"
              >
                <b-button v-b-toggle="'accordion-' + location.id">
                  <div class="list-header">
                    <div class="banner-name">
                      {{ location.short_name }}:{{ location.name }} ---
                      {{ location.width }}*{{ location.height }}
                    </div>
                  </div>
                  <span class="when-opened" style="margin-left: 11px">
                    <ChevronUpIcon />
                  </span>
                  <span class="when-closed" style="margin-left: 11px">
                    <ChevronDownIcon />
                  </span>
                </b-button>

                <b-collapse
                  :id="'accordion-' + location.id"
                  accordion="my-accordion"
                  role="tabpanel"
                  visible
                >
                  <b-card-body>
                    <div class="banner-div">
                      <div class="header">
                        <b-form-checkbox
                          v-model="location.google_on"
                          name="check-button"
                          switch
                          >Google Ads
                          {{
                            location.google_on ? "On" : "Off"
                          }}</b-form-checkbox
                        >
                        <div class="input-div">
                          <b-form-input
                            v-if="location.google_on"
                            :placeholder="'Google slot id'"
                            v-model="location.google_ad_key"
                            :class="{
                              'form-group--error': !location.google_ad_key,
                            }"
                            class="input-search"
                          ></b-form-input>
                        </div>
                        <b-button
                          class="add-home-ads-button"
                          :disabled="
                            location.google_on && !location.google_ad_key
                          "
                          @click="activeGoogleAds(location)"
                          >{{$t('Apply')}}</b-button
                        >
                        <b-button
                          class="add-home-ads-button primary"
                          @click="openAddBannerDialog(location.id)"
                        >
                          <IconPlus />
                          {{$t('add banner')}}
                        </b-button>
                      </div>
                      <div class="banner-body-div">
                        <div
                          class="group-div"
                          v-for="(listsOfAd, index) in listsOfAds.data"
                          v-bind:key="index"
                        >
                          <div class="first-div" v-if="listsOfAd.customer">
                            <div
                              class="title"
                              @click="openAdsDetails(listsOfAd)"
                            >
                              {{ listsOfAd.customer.name }}
                            </div>
                          </div>
                          <div class="banner-details">
                            <div class="banner-details-first-div">
                              {{$t('contact name')}} :
                              {{ listsOfAd.contact_name }}<br />
                              {{$t('duration')}} :
                              {{
                                listsOfAd.start_date
                                  | formatDate($router.currentRoute.params.lang)
                              }}
                              <span v-if="listsOfAd.end_date">-</span>
                              {{
                                listsOfAd.end_date
                                  | formatDate($router.currentRoute.params.lang)
                              }}
                              <br />
                              {{$t('price per impression')}} :
                              {{ listsOfAd.cost_per_impression }}
                              {{ $t("baht") }}
                            </div>
                            <div class="banner-details-second-div">
                              {{$t('Advertising type')}} :
                              {{
                                listsOfAd.type == 2
                                  ? $t("monthly")
                                  : $t("according to display")
                              }}<br />
                              {{$t('website address')}} :
                              <span>{{ listsOfAd.website }}</span
                              ><br />
                              {{$t('budget')}} :
                              {{ listsOfAd.price.toLocaleString("th-TH") }}
                              {{ $t("baht") }}
                            </div>
                          </div>
                          <div class="banner-image">
                            <img :src="listsOfAd.image" class="responsive" :alt="$t('Advertise with us Buy-Sell')"/>
                            <div class="button-div">
                              <b-button
                                v-if="!listsOfAd.active"
                                @click="makeAdsActive(listsOfAd.id)"
                                class="icon-button startPause"
                              >
                                <IconPlay /> {{$t('Get started')}}
                              </b-button>
                              <b-button
                                class="icon-button startPause"
                                v-else
                                @click="makeAdsActive(listsOfAd.id)"
                              >
                                <IconPause />{{$t('pause')}}
                              </b-button>
                              <b-button
                                class="icon-button delete"
                                @click="deleteAds(listsOfAd.id)"
                              >
                                <TrashIcon />
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <b-row
                      cols="12"
                      lg="12"
                      class="text-center paginate-position"
                      v-if="listsOfAds && listsOfAds.meta.pageCount > 1"
                    >
                      <div
                        class="overflow-auto wrap-pagination d-none d-md-block"
                      >
                        <b-pagination-nav
                          v-model="page"
                          class="paginate-item"
                          :prev-text="$t('nextPg')"
                          :next-text="$t('prevPg')"
                          :link-gen="paginationNumber"
                          :number-of-pages="
                            listsOfAds &&
                            listsOfAds.meta &&
                            listsOfAds.meta.pageCount
                              ? listsOfAds.meta.pageCount
                              : 1
                          "
                          use-router
                        ></b-pagination-nav>
                      </div>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-tab>
        <b-tab>
          <template v-slot:title><div class="title">{{$t('The ad has expired')}}</div></template>
          <div class="tab-lists">
            <div class="banner-list-row">
              <b-card
                no-body
                class="mb-1"
                v-for="(location, index) in adsLocations"
                v-bind:key="index"
              >
                <b-button v-b-toggle="'expire-accordion-' + location.id">
                  <div class="list-header">
                    <div class="banner-name">
                      {{ location.short_name }}:{{ location.name }} ---
                      {{ location.width }}*{{ location.height }}
                    </div>
                  </div>
                  <span class="when-opened" style="margin-left: 11px">
                    <ChevronUpIcon />
                  </span>
                  <span class="when-closed" style="margin-left: 11px">
                    <ChevronDownIcon />
                  </span>
                </b-button>

                <b-collapse
                  :id="'expire-accordion-' + location.id"
                  accordion="my-accordion"
                  role="tabpanel"
                  visible
                >
                  <b-card-body>
                    <div class="banner-div">
                      <div class="banner-body-div">
                        <div
                          class="group-div"
                          v-for="(listsOfAd, index) in listsOfAds.data"
                          v-bind:key="index"
                        >
                          <div class="first-div" v-if="listsOfAd.customer">
                            <div
                              class="title"
                              @click="openAdsDetails(listsOfAd)"
                            >
                              {{ listsOfAd.customer.name }}
                            </div>
                          </div>
                          <div class="banner-details">
                            <div class="banner-details-first-div">
                              {{$t('contact name')}} :
                              {{ listsOfAd.contact_name }}<br />
                              {{$t('duration')}} :
                              {{
                                listsOfAd.start_date
                                  | formatDate($router.currentRoute.params.lang)
                              }}
                              <span v-if="listsOfAd.end_date">-</span>
                              {{
                                listsOfAd.end_date
                                  | formatDate($router.currentRoute.params.lang)
                              }}
                              <br />
                              {{$t('price per impression')}} :
                              {{ listsOfAd.cost_per_impression }}
                              {{ $t("baht") }}
                            </div>
                            <div class="banner-details-second-div">
                              {{$t('Advertising type')}} :
                              {{
                                listsOfAd.type == 2
                                  ? $t("monthly")
                                  : $t("according to display")
                              }}<br />
                              {{$t('website address')}} :
                              <span>{{ listsOfAd.website }}</span
                              ><br />
                              {{$t('budget')}} :
                              {{ listsOfAd.price.toLocaleString("th-TH") }}
                              {{ $t("baht") }}
                            </div>
                          </div>
                          <div class="banner-image">
                            <img :src="listsOfAd.image" class="responsive" :alt="$t('Advertise with us Buy-Sell')"/>
                            <div class="button-div">
                              <b-button
                                class="icon-button delete"
                                @click="deleteAds(listsOfAd.id)"
                              >
                                <TrashIcon />
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <b-row
                      cols="12"
                      lg="12"
                      class="text-center paginate-position"
                      v-if="listsOfAds && listsOfAds.meta.pageCount > 1"
                    >
                      <div
                        class="overflow-auto wrap-pagination d-none d-md-block"
                      >
                        <b-pagination-nav
                          v-model="page"
                          class="paginate-item"
                          :prev-text="$t('nextPg')"
                          :next-text="$t('prevPg')"
                          :link-gen="paginationNumber"
                          :number-of-pages="
                            listsOfAds &&
                            listsOfAds.meta &&
                            listsOfAds.meta.pageCount
                              ? listsOfAds.meta.pageCount
                              : 1
                          "
                          use-router
                        ></b-pagination-nav>
                      </div>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-tab>
        <b-tab v-if="screenId == 'homepage'">
          <template v-slot:title><div class="title">Add Google Client Id</div></template>
          <div class="tab-lists">
            <div class="banner-list-row">
              <b-card
                no-body
                class="mb-1"
               
              > <b-card-body>
			  
            <div class="banner-div">
              <div class="header d-flex flex-row justify-content-start">
                <div class="input-div ">
                  <b-form-input
                    :placeholder="'Google Client id'"
                    v-model="google_client_id"
                    class="input-search"
                  ></b-form-input>
                </div>
                <b-button
                  class="add-home-ads-button ml-3"
                  :disabled="!google_client_id"
                  @click="updateGoogleClientId()"
                  >Apply</b-button
                >
              </div>
            </div>
			</b-card-body>
              </b-card>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <div class="model-div">
      <b-modal
        id="modal-add-banner-homepage"
        dialog-class="add-banner-homepage-dialog"
        size="md"
        centered
        hide-footer
        hide-header
        style="width: 560px"
      >
        <b-container fluid>
          <div class="dialog-header">
            <label>{{$t('add banner')}}</label>
            <div @click="closeAddBannerDialog" class="close-modal">
              <CloseIcon />
            </div>
          </div>
          <b-row class="mb-1 text-center" style="margin: 10px" v-if="false">
            <div class="wrapper">
              <b-spinner label="Loading..." variant="'primary'"></b-spinner>
            </div>
          </b-row>

          <b-form
            class="needs-validation"
            novalidate
            id="form-add-address"
            @submit.prevent="addAds"
          >
            <div class="wrapper">
              <b-form-group>
                <b-row>
                  <div class="form-group">
                    <b-form-input
                      list="my-list-id"
                      class="menu-dropdown"
                      id="customerId"
                      v-model="customerId"
                      :placeholder="$t('customer')"
                      autocomplete="off"
                      :class="{ 'is-invalid': $v.customerId.$error }"
                    ></b-form-input>

                    <datalist id="my-list-id">
                      <option
                        v-for="(customer, index) in customersList.data"
                        :key="index"
                        v-bind:value="
                          'Id: ' + customer.id + ' Name: ' + customer.name
                        "
                      ></option>
                    </datalist>

                    <b-form-invalid-feedback
                      >{{$t('Please enter company name')}}</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group">
                    <b-form-input
                      placeholder="contact name"
                      class="input-search price-input"
                      v-model="contactPersonName"
                      id="contactPersonName"
                      :class="{ 'is-invalid': $v.contactPersonName.$error }"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >{{$t('Please enter customer name')}}</b-form-invalid-feedback
                    >
                  </div>
                </b-row>

                <b-row>
                  <div class="form-group">
                    <b-dropdown no-flip
                      class="menu-dropdown"
                      v-model="selectedImpressionType"
                    >
                      <template v-slot:button-content>
                        <span>
                          {{
                            selectedImpressionType
                              ? selectedImpressionType
                              : $t("Advertising type")
                          }}
                          <ChevronDownIcon />
                        </span>
                      </template>

                      <b-dropdown-item
                        value="1"
                        @click="selectedImpressionType = 1"
                        >{{$t('according to display')}}</b-dropdown-item
                      >
                      <b-dropdown-item
                        value="2"
                        @click="selectedImpressionType = 2"
                        >{{$t('monthly')}}</b-dropdown-item
                      >
                    </b-dropdown>
                    <b-form-invalid-feedback
                      >Please select banner type</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group">
                    <b-form-input
                      :placeholder="$t('website address')"
                      class="input-search price-input"
                      v-model="websiteUrl"
                      id="websiteUrl"
                      :class="{ 'is-invalid': $v.websiteUrl.$error }"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Please enter website url</b-form-invalid-feedback
                    >
                  </div>
                </b-row>
                <b-row v-if="selectedImpressionType == 2">
                  <div class="form-group">
                    <label>{{$t('duration')}}</label>
                    <datepicker
                      class="date-input"
                      :language="th"
                      v-model="dateFrom"
                    ></datepicker>
                    <b-form-invalid-feedback
                      >{{$t('Please enter price per impression')}}</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group">
                    <label>{{$t('to')}}</label>
                    <datepicker
                      class="date-input"
                      :language="th"
                      v-model="dateTo"
                    ></datepicker>
                    <b-form-invalid-feedback
                      >{{$t('Please enter price per impression')}}</b-form-invalid-feedback
                    >
                  </div>
                </b-row>
                <b-row>
                  <div class="form-group" v-if="selectedImpressionType == 1">
                    <label>{{$t('price per impression')}}</label>
                    <div class="price-div">
                      <b-form-input
                        style="width: 200px"
                        :placeholder="$t('amount')"
                        class="input-search price-input"
                        v-model="costPerImpression"
                        id="costPerImpression"
                        :class="{ 'is-invalid': $v.costPerImpression.$error }"
                      ></b-form-input>
                      <label>{{ $t("baht") }}</label>
                    </div>
                    <b-form-invalid-feedback
                      >{{$t('Please enter price per impression')}}</b-form-invalid-feedback
                    >
                  </div>
                  <div class="form-group">
                    <label>{{$t('budget')}}</label>
                    <div class="price-div">
                      <b-form-input
                        style="width: 200px"
                        :placeholder="$t('amount')"
                        class="input-search price-input"
                        v-model="price"
                        id="price"
                        :class="{ 'is-invalid': $v.price.$error }"
                      ></b-form-input>
                      <label>{{ $t("baht") }}</label>
                    </div>
                    <b-form-invalid-feedback
                      >Please enter budget</b-form-invalid-feedback
                    >
                  </div>
                </b-row>
                <b-row>
                  <Fileuploader
                    name="files"
                    maxFiles="1"
                    accept="jpg, png, jpeg"
                    :multiple="false"
                    v-on:childToParent="getFile"
                    :fileUploaded="arrImageUploaded"
                    :theme="'thumbnails'"
								    :changeInput="' '"
                  />
                  <!-- <Fileuploader
                    name="files"
                    maxFiles="2"
                    :multiple="false"
                    v-on:childToParent="getFile"
                    :fileUploaded="arrImageUploaded"
                  /> -->
                </b-row>
              </b-form-group>
              <b-row>{{$t('Please upload an image file.')}} jpg, png {{$t('or')}} gif {{$t('only')}}</b-row>
            </div>
            <div class="wrap-btn-send">
              <b-button class="btn-send success-button" id="save" type="submit"
                >{{$t('record')}}</b-button
              >
            </div>
          </b-form>
        </b-container>
      </b-modal>

      <b-modal id="modal-ads-details" centered hide-footer hide-header>
        <b-container>
          <div class="dialog-header">
            <label>{{$t('Properdee Co Ltd')}}</label>
            <div @click="closeAdsDetails" class="close-modal">
              <CloseIcon />
            </div>
          </div>
          <b-row class="mb-1 text-center" style="margin: 10px" v-if="false">
            <div class="wrapper">
              <b-spinner label="Loading..." variant="'primary'"></b-spinner>
            </div>
          </b-row>
          <b-row>
            <div class="active-inactive-row">
              <div>
                {{$t('expire')}} ({{ selectedCustomerDetails.advertismentsInactive }})
              </div>
              <div>
                {{$t('Advertising')}}
                <span>({{ selectedCustomerDetails.advertismentsActive }})</span>
              </div>
              <div>
                {{ $t("all") }}
                <span>({{ selectedCustomerDetails.advertismentsTotal }})</span>
              </div>
            </div>
            <div class="address">
              <h5>{{$t('address')}} :</h5>
              <div>
                {{ selectedCustomerDetails.address }}
              </div>
            </div>
            <div class="email-div">
              <h5>{{$t('contact')}} :</h5>
              <div class="row">
                <div>{{$t('phone')}} : {{ selectedCustomerDetails.phone_number }}</div>
                <div>
                  {{$t('Email')}} : <a :href="'mailto:'+selectedCustomerDetails.email" style="color:var(--projectPrimaryColor)"> {{ selectedCustomerDetails.email }}</a>
                </div>
              </div>
            </div>
            <div class="total-div">
              <div class="row">
                <div>{{$t('duration')}}</div>

                <div>
                  {{
                    selectedCustomerDetails.adsStart_date
                      | formatDate($router.currentRoute.params.lang)
                  }}
                  <span v-if="selectedCustomerDetails.adsEnd_date">{{$t('to')}}</span>
                  {{
                    selectedCustomerDetails.adsEnd_date
                      | formatDate($router.currentRoute.params.lang)
                  }}
                </div>
              </div>
              <div class="row" style="margin-top: 5px">
                <div>{{$t('price')}}</div>
                <div>
                  {{ selectedCustomerDetails.adsPrice.toLocaleString("th-TH") }}
                  {{ $t("baht") }}
                </div>
              </div>
            </div>
          </b-row>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const moment = require("moment");
import { en, th } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import Fileuploader from "@/components/newFileuploader";
import { required, email, integer, minLength } from "vuelidate/lib/validators";

// Icons
import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";
import ChevronUpIcon from "vue-material-design-icons/ChevronUp.vue";
import CloseIcon from "vue-material-design-icons/Close.vue";
import IconPlus from "@/components/icons/IconPlus/index";
// import EyeIcon from "@/components/icons/IconEye/index";
import TrashIcon from "@/components/icons/IconTrash";
import IconPlay from "@/components/icons/IconPlay/index.vue";
import IconPause from "@/components/icons/IconPause/index.vue";

export default {
  components: {
    CloseIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    IconPlus,
    // EyeIcon,
    TrashIcon,
    Fileuploader,
    Datepicker,
    IconPlay,
    IconPause,
  },
  data() {
    return {
      customerId: null,
      contactPersonName: null,
      websiteUrl: null,
      price: null,
      costPerImpression: null,
      loading: false,
      openCustomer: true,
      is_active: false,
      arrImageUploaded: [],
      imageArray: [],
      selectedImpressionType: 1,
      dateFrom: new Date(),
      dateTo: new Date().setDate(new Date().getDate() + 7),
      en: en,
      th: th,
      screenId: "homepage",
      adsLocations: [],
      locationId: null,
      listsOfAds: {
        data: [],
        meta: {
          pageCount: 0,
        },
      },
      page: this.$route.params.id ? this.$route.params.id : 1,
      customersList: [],
      searchText: "",
      selectedCustomerDetails: {
        adsPrice: 0,
      },
      tabIndex: 0,
      active: false,
      google_client_id: null,
    };
  },
  validations: {
    customerId: { required, min: minLength(1) },
    contactPersonName: { required, min: minLength(2) },
    selectedImpressionType: { required, min: minLength(1) },
    websiteUrl: { required, min: minLength(2) },
    dateFrom: { required },
    dateTo: { required },
    costPerImpression: { min: minLength(1) },
    price: { required, min: minLength(1) },
  },
  filters: {
    formatDate(value, lang) {
      if (!value) return;
      let now = moment(new Date());
      let newVal = moment(value);
      // if(now.isSame(newVal, 'day')) return
      return moment(value).local("th").format("DD MMM YYYY");
    },
    formatHour(value, lang) {
      if (!value) return;
      return moment(value).local("th").format("HH:mm");
    },
  },
  created(){
    this.getGoogleClientId();
  },
  watch: {
    searchText: function (val) {
      this.loading = true;
      this.page = 1;
      if (!this.awaitingSearch) {
        setTimeout(() => {
          this.getListOfCustomer(true);
          this.awaitingSearch = false;
        }, 1000); // 1 sec delay
      }
      this.awaitingSearch = true;
    },
    "$route.params.screen": function (val) {
      
      this.screenId = val;
      this.tabIndex = 0;
      this.getLocationsOfScreen(val);
    },
    tabIndex: function (val) {
      if (val == 0) {
        this.active = false;
      } else {
        this.active = true;
      }
    },
    page: function (val) {
      this.getListOfAdsForLocation();
    },
  },
  mounted() {
    this.getLocationsOfScreen(this.$route.params.screen);
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (isJustShown) {
        // 
        this.locationId = collapseId.match(/\d+/g).map(Number);
        this.getListOfAdsForLocation();
      }
    });
  },
  methods: {
    ...mapActions("AdsController", [
      "GET_ADVERTISMENT_LOCATIONS_FOR_SCREEN",
      "GET_ADVERTISMENT_FOR_LOCATIONS",
      "CREATE_ADVERTISMENT_FOR_LOCATIONS",
      "DELETE_ADVERTISMENT_FOR_LOCATIONS",
      "GET_CUSTOMER_LIST_FOR_ADS",
      "MAKE_ADS_ACTIVE",
      "SWITCH_GOOGLE_ADS",
      "GET_CUSTOMER_DETAILS",
      "UPDATE_GOOGLE_CLIENT_ID",
      "GET_GOOGLE_CLIENT_ID"
    ]),
    getGoogleClientId(){
      this.GET_GOOGLE_CLIENT_ID().then((data)=>{
          this.google_client_id=data.data.google_client_id;
      })
    },
    updateGoogleClientId() {
      let obj = {
        google_client_id: this.google_client_id,
      };
      this.UPDATE_GOOGLE_CLIENT_ID(obj).then((data) => {
        
      });
    },
    reset() {
      this.listsOfAds = {
        data: [],
        meta: {
          pageCount: 0,
        },
      };
      this.page = this.$route.params.id ? this.$route.params.id : 1;
      this.customersList = [];
      this.searchText = "";
      this.selectedCustomerDetails = {
        adsPrice: 0,
      };

      customerId = null;
      contactPersonName = null;
      websiteUrl = null;
      price = null;
      costPerImpression = null;
      selectedImpressionType = 1;
      dateFrom = new Date();
      dateTo = new Date().setDate(new Date().getDate() + 7);
    },
    async makeAdsActive(id) {
      let vm = this;
      vm.loading = true;
      vm.MAKE_ADS_ACTIVE({ id: id })
        .then((data) => {
          
          vm.loading = false;
          vm.getListOfAdsForLocation();
          this.$bvToast.toast("Ad Is Active", {
            title: "Ad Is Active",
            variant: "success",
            solid: true,
          });
        })
        .catch((err) => {
          
          vm.loading = false;
          this.$bvToast.toast(err, {
            title: "Ad Is Active",
            variant: "error",
            solid: true,
          });
        });
    },

    getLocationIdFromClick(id) {
      this.locationId = id;
      // this.getListOfAdsForLocation();
    },
    async getLocationsOfScreen(screen) {
      let vm = this;
      vm.loading = true;
      await this.GET_ADVERTISMENT_LOCATIONS_FOR_SCREEN({
        group_name: screen,
      })
        .then((data) => {
          
          vm.loading = false;
          // 
          this.adsLocations = data.data;
          // 
        })
        .catch((err) => {
          
          vm.loading = false;
        });
    },

    async getListOfAdsForLocation() {
      let vm = this;
      vm.loading = true;
      await this.GET_ADVERTISMENT_FOR_LOCATIONS({
        id: vm.locationId,
        active: this.active,
      })
        .then((data) => {
          
          vm.loading = false;
          vm.listsOfAds = data;
        })
        .catch((err) => {
          
          vm.loading = false;
        });
    },
    async deleteAds(adsId) {
      let vm = this;
      vm.loading = true;
      await this.DELETE_ADVERTISMENT_FOR_LOCATIONS({ id: adsId })
        .then((data) => {
          
          vm.loading = false;
          this.getListOfAdsForLocation();
          this.$bvToast.toast("Ads deleted", {
            title: "Ads deleted",
            variant: "success",
            solid: true,
          });
        })
        .catch((err) => {
          
          vm.loading = false;
          this.$bvToast.toast(err, {
            title: "Ads deleted",
            variant: "success",
            solid: true,
          });
        });
    },
    openAddBannerDialog(locationId) {
      this.locationId = locationId;
      this.getListOfCustomer();
      this.$bvModal.show("modal-add-banner-homepage");
    },
    closeAddBannerDialog() {
      this.$bvModal.hide("modal-add-banner-homepage");
      this.getListOfAdsForLocation();
    },
    getFile(ev) {
      
      this.imageArray = ev;
    },
    async addAds() {
      let vm = this;
      this.$v.$touch();
      vm.loading = true;
      if (this.$v.$error) {
        
        vm.loading = false;
        return;
      }
      if (!this.imageArray.length) {
        vm.loading = false;
        this.$bvToast.toast("Please add 1 image", {
          title: "Image",
          variant: "error",
          solid: true,
        });
      }

      var formData = new FormData();
      formData.append(
        "customer_id",
        vm.customerId.match(/\d+/g).map(Number)[0]
      );
      formData.append("contact_name", vm.contactPersonName);
      formData.append("type", vm.selectedImpressionType);
      formData.append("start_date", moment(vm.dateFrom).format());
      if (vm.selectedImpressionType == 2) {
        formData.append("end_date", moment(vm.dateTo).format());
      }
      if (vm.selectedImpressionType == 1) {
        formData.append("cost_per_impression", vm.costPerImpression);
      }

      formData.append("price", vm.price);
      formData.append("ad_location_id", vm.locationId);
      formData.append("website", vm.websiteUrl);
      if (vm.imageArray && vm.imageArray.length) {
        vm.imageArray.forEach((file) => {
          formData.append("files", file.file);
        });
      }

      await this.CREATE_ADVERTISMENT_FOR_LOCATIONS({ obj: formData })
        .then((data) => {
          
          vm.loading = false;
          vm.closeAddBannerDialog();
          this.$bvToast.toast("Ads Created", {
            title: "Ads Created",
            variant: "success",
            solid: true,
          });
        })
        .catch((err) => {
          
          vm.loading = false;
          this.$bvToast.toast(err, {
            title: "Ads Created",
            variant: "error",
            solid: true,
          });
        });
    },

    openAdsDetails(ads) {
      let vm = this;

      vm.GET_CUSTOMER_DETAILS({ id: ads.customer.id })
        .then(({ data }) => {
          
          vm.loading = false;
          vm.selectedCustomerDetails = data;
          vm.selectedCustomerDetails.adsStart_date = ads.start_date;
          vm.selectedCustomerDetails.adsEnd_date = ads.end_date;
          vm.selectedCustomerDetails.adsPrice = ads.price;
          if (vm.selectedCustomerDetails) {
            vm.$bvModal.show("modal-ads-details");
          }
        })
        .catch((err) => {
          
          vm.loading = false;
          this.$bvToast.toast("Error getting customer details", {
            title: "Error",
            variant: "error",
            solid: true,
          });
        });
    },
    async getListOfCustomer(filterd) {
      
      let vm = this;
      vm.loading = true;
      if (filterd) {
        vm.page = 1;
      }
      await vm
        .GET_CUSTOMER_LIST_FOR_ADS({ searchText: vm.searchText })
        .then((data) => {
          
          vm.loading = false;
          this.customersList = data;
        })
        .catch((err) => {
          
          vm.loading = false;
        });
    },
    closeAdsDetails() {
      this.$bvModal.hide("modal-ads-details");
    },
    paginationNumber(pageNum) {
      return pageNum === 1 ? "?page=1" : `?page=${pageNum}`;
    },
    async activeGoogleAds(location) {
      let vm = this;
      await vm
        .SWITCH_GOOGLE_ADS({
          id: location.id,
          google_ad_on: location.google_on,
          google_ad_key: location.google_ad_key,
        })
        .then((data) => {
          
          vm.getListOfAdsForLocation();
          vm.$bvToast.toast("Google Ads Updated", {
            title: "Google Ads",
            variant: "success",
            solid: true,
          });
        })
        .catch((err) => {
          
          vm.loading = false;
          this.$bvToast.toast(err, {
            title: "Try again",
            variant: "error",
            solid: true,
          });
        });
    },
  },
};
</script>

<style lang="scss" >
@import "adsCreateAds.scss";
</style>
